import { deserializeStatements } from "../components/tactic/tacticModel";

export const POS_SCALE = 10000;

export const playerFromBackend = (p, i) => ({
  id:         p.id,
  frontendId: i,
  x:          p.x_pos / POS_SCALE,
  y:          p.y_pos / POS_SCALE,
  name:       p.name || "",
  tacticId:   p.tactic_id,
  isStarter:  p.is_server,
  isGoalkeeper: p.is_goalkeeper ?? false,
});

export const playerToBackend = (p) => ({
  id:        p.id,
  x_pos:     Math.round(p.x * POS_SCALE),
  y_pos:     Math.round(p.y * POS_SCALE),
  name:      p.name || null,
  tactic_id: p.tacticId,
  is_server: p.isStarter,
  is_goalkeeper: p.isGoalkeeper ?? false,
});

export const normalizeTactic = (t) => ({ ...t, statements: deserializeStatements(t.tokens ?? []) });
